import { DirectoryAutocompleteField } from 'features';
import { lodash } from 'helpers';
import { useIsFormEditable } from 'hooks';
import { formatDecimalValue } from 'libs/form/fields/DecimalField/helpers';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import { OrderSection } from 'modules/order/common/components';
import { MAX_FLOATING_POINTS } from 'modules/order/common/constants';
import { Field } from 'modules/order/common/forms/orderForm';

import { useTransferVolumeSection } from './useTransferVolumeSection';

export const TransferVolumeSection = () => {
  const { t } = useTranslation();

  const {
    isDisabledPrice,
    isRequiredPrice,
    isDisabledTransactionAmount,
    currencies,
    nominalQuantity,
  } = useTransferVolumeSection();

  const isEditable = useIsFormEditable();

  return (
    <OrderSection
      fields={lodash.compact([
        <Field.Quantity
          fullWidth
          showRequiredMark
          label={t(
            'order.sections.transferVolumeSection.fields.quantity.label'
          )}
          name="transferVolume.quantity"
          placeholder={t(
            'order.sections.transferVolumeSection.fields.quantity.placeholder'
          )}
        />,
        <Input
          fullWidth
          readOnly
          disabled={isEditable}
          label={t(
            'order.sections.transferVolumeSection.fields.nominalQuantity.label'
          )}
          name="transferVolume.nominalQuantity"
          value={formatDecimalValue(nominalQuantity, MAX_FLOATING_POINTS, 0)}
        />,
        <Field.Decimal
          fullWidth
          disabled={!isEditable ? false : isDisabledPrice}
          label={t(
            'order.sections.transferVolumeSection.fields.unitPrice.label'
          )}
          maxFloatingPoints={MAX_FLOATING_POINTS}
          name="transferVolume.unitPrice"
          placeholder={
            isDisabledPrice
              ? undefined
              : t(
                  'order.sections.transferVolumeSection.fields.unitPrice.placeholder'
                )
          }
          showRequiredMark={isRequiredPrice}
        />,
        currencies ? (
          <DirectoryAutocompleteField<{ value: string; label: string }, false>
            key={`currency-field-${isDisabledPrice}`}
            fullWidth
            directorySchemaName={currencies.currency.directorySchemaName}
            disabled={!isEditable ? false : isDisabledPrice}
            fieldName={currencies.currency.fieldName}
            label={t(
              'order.sections.transferVolumeSection.fields.currency.label'
            )}
            name="transferVolume.currency"
            placeholder={
              !isDisabledPrice
                ? t(
                    'order.sections.transferVolumeSection.fields.currency.placeholder'
                  )
                : undefined
            }
            showRequiredMark={isRequiredPrice}
          />
        ) : (
          <Field.Text
            fullWidth
            readOnly
            disabled={isEditable}
            label={t(
              'order.sections.transferVolumeSection.fields.currency.label'
            )}
            name="transferVolume.currency.label"
          />
        ),

        <Field.Decimal
          fullWidth
          disabled={!isEditable ? false : isDisabledTransactionAmount}
          label={t(
            'order.sections.transferVolumeSection.fields.transactionAmount.label'
          )}
          maxFloatingPoints={MAX_FLOATING_POINTS}
          maxIntegerLength={0}
          name="transferVolume.transactionAmount"
          placeholder={
            !isDisabledPrice
              ? t(
                  'order.sections.transferVolumeSection.fields.transactionAmount.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequiredPrice}
        />,
      ])}
      title={t('order.sections.transferVolumeSection.title')}
    />
  );
};
